import React, { Component } from 'react'
import { connect } from 'react-redux'
import { openEditMarkerModal } from '../../../../store/actions/sketchActions';
import EditDefect from './EditDefect';
import EditElevation from './EditElevation';

class EditMarkerWrapper extends Component {
    componentDidMount() {
        this.props.openEditMarkerModal();
    }

    render() {
        const { selectedMarkerid, floorMarkers, modalWidthMedium, modalTitleStyle, mut, isElevationMap, defectMarker, defectMarkers, appControl } = this.props;
        const { modalInfoTextStyle } = appControl;
        const floorMarker = floorMarkers ? selectedMarkerid in floorMarkers ? floorMarkers[selectedMarkerid] : null : null;
        const relevantEditMarkerComponent = floorMarker ? floorMarker.identifier === "0" ? <EditDefect defectMarkers={defectMarkers} defectMarker={defectMarker} selectedMarkerid={selectedMarkerid} isElevationMap={isElevationMap} /> : floorMarker.identifier === "1" ? <EditElevation selectedMarkerid={selectedMarkerid} isElevationMap={isElevationMap} /> : <p>Marker identity not recognized</p> : <p>Marker not found</p>
        const floorMarkerText = mut.text[floorMarker.identifier];

        return (
            <div className="dynamicModalContainer">
                <div className="dynamicModal">
                    <h5 style={modalTitleStyle}>Edit {floorMarkerText}</h5>
                    <p style={modalInfoTextStyle}> You can edit {floorMarkerText} settings and update them instantaneously</p>
                    {relevantEditMarkerComponent}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        modalStyles: state.appControl.modalStyles,
        modalWidthMedium: state.appControl.modalWidthMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
        floorMarkers: state.firestore.data.FloorMarkers,
        mut: state.marker,
        appControl: state.appControl,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        openEditMarkerModal: () => dispatch(openEditMarkerModal()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditMarkerWrapper)
